<template>
    <span>{{displayValue}}</span>
</template>
<script>
    export default {
        props: { value: { type: Number, default: 0 } },
        computed: {
            displayValue() {
                if (this.value > 10000) {
                    return `${(this.value / 1000000).toFixed(2).toLocaleString()} km\xB2`;
                } else if (this.value > 0) {
                    return `${(this.value).toFixed(2).toLocaleString()} m\xB2`;
                } else {
                    return '';
                }
            }
        }
    };
</script>
